require('./CometServerApi');

function get_fromServer(method, callback){
	if(method==null)
		return false;
	$.ajax({
		url: method,
		method: "GET",
		success: function(data) {
			callback(data);
		}
	});
}


function get_unread(){
	get_fromServer(`/get_unread_msgs`, function(data){
		try{
			var response = JSON.parse(data);
		}catch(e){
			var response = {};
		}
		try{
			$('.unread_msgs').html(response.unread ?? 0);
		}catch{
			$('.unread_msgs').html(0);
		}	
	});
}

var sound;
$('html').one('mousedown',function(ev){
	if(sound==null){
		sound = new Audio("/assets/61767^ding.mp3"); 
		sound.load(); // load the audio data
		sound.volume=1; // make sure the volume is all the way up, though this doesn't work on iOS
	}
});
var soundClick = (function () {
	if(sound==null){
		sound = new Audio();
		sound.src = "/assets/61767^ding.mp3";
	}
	return function () {
		sound.play();
	};
})();


function start_comet(ws_token, user_id){
	CometServer().onAuthFalill(function(){
		let timerId_wot = setTimeout(function tick() {
			get_fromServer(`/getwskey/`, function(data){
				try{
					let datar = JSON.parse(data);
					let wskey = datar.wskey;
					if(wskey==null || wskey==''){
						timerId_wot = setTimeout(tick, 10000);
					}else{
						ws_token=wskey;
						CometServer().restart({dev_id:0, user_key:ws_token, user_id:user_id, node: window.cppcomet.node})
					}
				}catch(e){
					console.warn(e);
					timerId_wot = setTimeout(tick, 10000);
				}
			});
			
		}, 10);
	});
	CometServer().start({dev_id:0, user_key:ws_token, user_id:user_id, node: window.cppcomet.node});
	CometServer().subscription("msg", function(e){
		if(e.server_info.event=="logout"){
			location.reload();
		}
		if(e.server_info.event=="message" || e.server_info.event=="actual" || e.server_info.event=="archieve"){
			get_unread();
			
			if(e.data.from_id!=user_id){
				if(CometServer().isMaster()){
					soundClick();
				}
			}
		}
	});
	setInterval(function(){
		if(CometServer().isAuthorized()===false){
			get_fromServer(`/getwskey/`, function(data){
				try{
					let datar = JSON.parse(data);
					let wskey = datar.wskey;
					if(wskey==null || wskey==''){
					}else{
						ws_token=wskey;
						CometServer().restart({dev_id:window.cppcomet.dev_id, user_key:ws_token, user_id:user_id, node: window.cppcomet.node})
					}
				}catch(e){
					console.warn(e);
				}
			});
		}
	},10000);
}

if(!CometServer().isAuthorized()){
if(ws_token!="" && user_id!=""){
		start_comet(ws_token,user_id);
	}else{
		let timerId_wot = setTimeout(function tick() {
			get_fromServer(`/getwskey/`, function(data){
				try{
					let datar = JSON.parse(data);
					let wskey = datar.wskey;
					if(wskey==null || wskey==''){
						timerId_wot = setTimeout(tick, 10000);
					}else{
						ws_token=wskey;
						start_comet(ws_token,user_id);
					}
				}catch(e){
					console.warn(e);
					timerId_wot = setTimeout(tick, 10000);
				}
			});
			
		}, 10);
	}
}
